import { Text } from "@chakra-ui/react";
import { useContext, useState } from "react";
import { useFetchAccount } from "../../api/accounts/accounts";
import LoadingBox from "../../components/common/LoadingBox";
import InfoBox from "../../components/common/PageInfo/InfoBox";
import { AccountContext } from "../../context/AccountContextComponent";
import useAccountId, {
  useBreadcrumbsWithCustomDomain,
} from "../../hooks/customDomainHooks";
import PageShell from "../../layout/PageShell";
import ViewEmployees from "./ViewEmployees";

const PeoplePage = () => {
  const { accountId } = useAccountId();
  const { data, error, isLoading, isError } = useFetchAccount(accountId || "");
  const { currentProfile } = useContext(AccountContext);
  const [pageInfoEditMode, setPageInfoEditMode] = useState(false);

  const breadcrumbs = useBreadcrumbsWithCustomDomain([
    { type: "HOME", href: `/${accountId}/home` },
    { name: "People" },
  ]);

  if (isLoading) {
    return <LoadingBox />;
  }
  if (isError) {
    return <Text>{error.message}</Text>;
  }
  const profileRole = currentProfile?.role;

  return (
    <PageShell
      breadcrumbs={breadcrumbs}
      menuItems={[
        {
          type: "CREATE_PAGE_INFO",
          pageType: "PEOPLE",
        },
      ]}
      setPageInfoEditMode={setPageInfoEditMode}
    >
      {isError && <Text>{error.message}</Text>}
      <InfoBox
        pageInfoType={"PEOPLE"}
        setPageInfoEditMode={setPageInfoEditMode}
        pageInfoEditMode={pageInfoEditMode}
      />

      <ViewEmployees
        members={data.profiles}
        allowEdit={["ADMIN", "OWNER", "PARTNER"].includes(profileRole)}
      />
    </PageShell>
  );
};

export default PeoplePage;
